import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { ICustomDotsStyles } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultDots/styled';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const CustomNukaCarousel = styled(NukaCarousel)`
    padding: 4px 0 12px 0;
    
    & img {
        width: auto !important;
        max-height: 72px;
        margin: auto;
    }

    .slider-slide {
        display: flex !important;
        justify-content: center;
        align-items: center;
    }
    
    /**
    fix safari browser
     */
    .slider-frame {
        border-radius: 24px;
    }

    .slider-control-bottomcenter {
        bottom: -8px !important;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        padding: 6px 0 16px 0;

        & img {
            max-height: 112px;
        }

        .slider-frame {
            border-radius: 32px;
        }
    }
`;

export const customDotsStyles: ICustomDotsStyles = {
    dotContainer: {
        width: '6px',
        height: '6px',
    },
    dot: {
        background: COLORS.Outline_Dark,
        opacity: .2,
        borderRadius: '50%',
    },
    activeDot: {
        background: COLORS.Outline_Dark,
        opacity: 1,
        borderRadius: '50%',
    },
};
